import type { RollbackCommandData } from '@festina/life-general-types/life'

import { useScenarioContext } from '../../context/scenarioContext'
import { useHook } from '../../lenteHooks'
import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'
import { RollbackCommandForm } from './RollbackCommandForm'

export const LifeRollbackCommandForm = ({
  commandData,
  shouldSkipFrame,
  ...props
}: CommandDataFormProps<RollbackCommandData>) => {
  const { scenarioIdForRequestHeader } = useScenarioContext()
  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()

  const { data: frame } = useHook('fetchers.life.useFetchRollbackFrame')(
    {
      tenantId,
      ownerId,
      scenarioId: scenarioIdForRequestHeader,
      requestBody: {
        _type: 'RollbackCommandData',
        ...commandData,
      },
    },
    {
      enabled: shouldSkipFrame !== true,
    },
  )

  return (
    <RollbackCommandForm frame={frame} commandData={commandData} {...props} />
  )
}
